module.exports = {
      id: "vikatan-tv-usage",
      viewBox: "0 0 213 43",
      url: "/" + "sprite-036dd45d0e77a995aefc8cbeaab2becc.svg#vikatan-tv",
      toString: function () {
        return this.url;
      }
    }